/* eslint-disable no-console */ /* eslint-disable guard-for-in */ import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { logMap } from "./log-map";
import * as util from "./utils";
import { getConeDevInfo } from "./utils/dev-info";
import { getClientExtraInfo } from "./utils/client-extra-info";
import parseEagleeyeId from "./utils/parseEagleeyeId";
import { getBizLanguage } from "./utils/i18n";
import { getBizModuleInfo } from "./utils/biz-module-info";
/**
 * 初始化需要支持hook的方法
 */ var needSupportHookFuncArr = [
    "logError",
    "logPerf",
    "logPv",
    "logApi",
    "logEvent",
    "logSpeed",
    "logCalc",
    "logForm",
    "logCustom",
    "logBlankScreen",
    "logRunTime",
    "logPerformance",
    "logBizFlow",
    "logAutoAction",
    "logABTest",
    "logPageText",
    "send",
    "log"
];
var startTime = new Date().getTime();
var Core = /*#__PURE__*/ function() {
    "use strict";
    function Core(config, pipe) {
        var _this = this;
        _class_call_check(this, Core);
        _define_property(this, "config", void 0);
        // 用于存放上报的日志
        _define_property(this, "queue", []) // @todo类型
        ;
        // 数据预上报
        _define_property(this, "pipe", []);
        // 用于存放需要拿到数据再进行上报的日志
        _define_property(this, "requiredFieldQueue", []);
        // 存放安装的插件的卸载方法
        _define_property(this, "pluginsToUninstall", []);
        _define_property(this, "pvIdMap", {});
        // 文案缓存
        _define_property(this, "pageTextCache", new Map());
        // 存储每个 pvId 的生成时间
        _define_property(this, "pvIdTimestamps", new Map());
        /**
   * sdk实例状态，init: 初始化，installed: 已安装插件, uninstalled: 已卸载插件
   */ _define_property(this, "status", "init");
        _define_property(this, "bizFlowInfoMap", {});
        _define_property(this, "bizFlowCacheKeySplitStr", "___");
        /**
   * 插件配置项
   */ _define_property(this, "pluginConfigMap", {});
        _define_property(this, "setConfig", function(newConfig) {
            _this.config = util.shadowMerge(_this.config, newConfig);
            // 监听setConfig
            _this.sendRequiredFields(newConfig);
        });
        /**
   * 获取配置项
   * @param keys
   */ _define_property(this, "getConfig", function(keys) {
            if (typeof keys === "string") {
                return _this.config[keys];
            } else if (typeof keys === "object") {
                var _$config = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        _$config[key] = _this.config[key];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return _$config;
            } else {
                return _this.config;
            }
        });
        /**
   * 生成随机id
   * https://yuque.antfin-inc.com/alsc-sherlock/logger/qxt4xp
   */ _define_property(this, "generateRandomId", function() {
            return util.uuid();
        });
        /**
   * 生成pvID
   */ _define_property(this, "generatePvId", function() {
            var pvId = _this.generateRandomId();
            _this.setConfig({
                pvId: pvId
            });
            return pvId;
        });
        /**
   * 生成sessionId
   */ _define_property(this, "generateSid", function() {
            var sid = _this.generateRandomId();
            _this.setConfig({
                sid: sid
            });
            return sid;
        });
        /**
   * 生成uid
   */ _define_property(this, "generateUid", function() {
            var uid = _this.getUidFromCookie() || "";
            _this.setConfig({
                uid: uid
            });
            return uid;
        });
        /**
   * 从cookie中获取uid，不同端的实现方式不同，在SDK主包中覆盖此方法
   */ _define_property(this, "getUidFromCookie", function() {
            return "";
        });
        /**
   * 添加beforeHooks
   * @param func
   * @param excuteFunc
   */ _define_property(this, "before", function(func, excuteFunc) {
            // 找到this上需要被挂在执行的方法
            var currentFunc = typeof func === "function" ? func : _this[func];
            if (typeof currentFunc === "function") {
                currentFunc.prototype = currentFunc.prototype || {};
                var hasHooks = Array.isArray(currentFunc.prototype.beforeHooks);
                if (!hasHooks) {
                    currentFunc.prototype.beforeHooks = [
                        excuteFunc
                    ];
                } else {
                    currentFunc.prototype.beforeHooks.push(excuteFunc);
                }
            } else {
                console.warn("currentFunc不是Core的方法");
            }
        });
        /**
   * 添加afterHooks
   * @param func
   * @param excuteFunc
   */ _define_property(this, "after", function(func, excuteFunc) {
            // 找到this上需要被挂在执行的方法
            var currentFunc = typeof func === "function" ? func : _this[func];
            if (typeof currentFunc === "function") {
                currentFunc.prototype = currentFunc.prototype || {};
                var hasHooks = Array.isArray(currentFunc.prototype.afterHooks);
                if (!hasHooks) {
                    currentFunc.prototype.afterHooks = [
                        excuteFunc
                    ];
                } else {
                    currentFunc.prototype.afterHooks.push(excuteFunc);
                }
            } else {
                console.warn("currentFunc不是Core的方法");
            }
        });
        /**
   * 合并上报参数
   * @param options
   */ _define_property(this, "processSendData", function(options) {
            // 获取自采集的参数和配置的参数
            var params = {};
            var spmAb = util.getSpmAB();
            var _this_config = _this.config, pvId = _this_config.pvId, uid = _this_config.uid, sid = _this_config.sid;
            var _this_config1 = _this.config, accountType = _this_config1.accountType, employeeNumber = _this_config1.employeeNumber, spaRouteType = _this_config1.spaRouteType;
            var _this_config2 = _this.config, _this_config_env = _this_config2.env, env = _this_config_env === void 0 ? "prod" : _this_config_env, version = _this_config2.version, grey = _this_config2.grey, _this_config_ignoredQueries = _this_config2.ignoredQueries, ignoredQueries = _this_config_ignoredQueries === void 0 ? [] : _this_config_ignoredQueries;
            if (!pvId) {
                pvId = _this.generatePvId();
            }
            if (!sid) {
                sid = _this.generateSid();
            }
            if (!uid) {
                uid = _this.generateUid();
            }
            if (accountType) {
                params.account_type = accountType;
            }
            if (employeeNumber) {
                params.employee_number = employeeNumber;
            }
            // 获取页面研发信息
            params.cone_dev_info = getConeDevInfo(spaRouteType);
            // 获取客户端额外的信息（时区、语言、etc）
            params.client_extra_info = getClientExtraInfo();
            // 获取业务配置的模块信息
            params.biz_module_info = getBizModuleInfo(_this.config.bizModuleInfo);
            params.pid = _this.config.pid;
            params.ua = typeof navigator === "object" && navigator ? navigator.userAgent : "";
            params.uid = uid;
            params.username = _this.config.username || "";
            params.user_type = _this.config.userType || "";
            params.spm_a = spmAb.a;
            params.spm_b = spmAb.b;
            params.pv_id = pvId;
            params.sid = sid;
            params.env = env;
            params.version = version;
            params.grey = grey;
            // 从加载到问题发生的时间（s）
            params.delay = parseFloat(((new Date().getTime() - startTime) / 1000).toFixed(2));
            // 上报客户端时间戳
            params.client_timestamp = new Date().getTime();
            var commonInfo = util.getCommonInfo(ignoredQueries, _this.config);
            var extInfo = _this.getExtInfo(ignoredQueries, _this.config);
            Object.assign(commonInfo, extInfo);
            // 上报config中的c1~c10字段
            for(var key in _this.config){
                if (/^c[1-9]0?$/.test(key)) {
                    var ck = key;
                    params[ck] = _this.config[ck];
                }
            }
            // param中的同名参数可覆盖默认参数，即用户上报优先
            params = Object.assign(commonInfo, params);
            var finalParams = util.shadowMerge(params, options);
            for(var key1 in finalParams){
                // 处理undefined字段
                if (finalParams[key1] === undefined) {
                    finalParams[key1] = "";
                }
            }
            if (util.shouldSkipUSIPReport(_this.config, finalParams.client_extra_info)) {
                return null;
            }
            finalParams.pv_id = _this.fixPvId(finalParams.pv_id, finalParams.url);
            // 对需要长时间存储的日志打标
            if (params.needLongStore === "Y" && params.client_extra_info) {
                params.client_extra_info.need_long_store = "Y";
            }
            delete params.needLongStore;
            return finalParams;
        });
        /**
   * 获取系统通用信息, 不同端的实现方式不同，在SDK主包中覆盖此方法
   * @param ignoredQueries
   * @param config
   * @returns
   */ _define_property(this, "getExtInfo", function() {
            return {};
        });
        _define_property(this, "checkRequiredFields", function(param) {
            var _this_config_requiredFields;
            return (_this_config_requiredFields = _this.config.requiredFields) === null || _this_config_requiredFields === void 0 ? void 0 : _this_config_requiredFields.every(function(key) {
                return param[key] !== undefined && param[key] !== null && (typeof param[key] !== "number" || !Number.isNaN(param[key]));
            });
        });
        /**
   * 过滤掉不在requiredFields数组的值
   * @param IConfig
   */ _define_property(this, "filterRequiredFields", function(obj) {
            var _requiredFields;
            var requiredFields = _this.config.requiredFields;
            var filterVal = {};
            (_requiredFields = requiredFields) === null || _requiredFields === void 0 ? void 0 : _requiredFields.forEach(function(item) {
                if (Object.hasOwnProperty.call(obj, item)) {
                    filterVal[item] = obj[item];
                }
            });
            return filterVal;
        });
        /**
   * 上报requiredFieldQueue队列中的值
   * @param IConfig
   */ _define_property(this, "sendRequiredFields", function(newConfig) {
            var queue = _this.requiredFieldQueue;
            var len = queue.length;
            while(len > 0){
                len--;
                var logItem = queue[len];
                if (newConfig) {
                    // 监听setConfig
                    var filterVal = _this.filterRequiredFields(newConfig);
                    var newItem = util.shadowMerge(logItem, filterVal);
                    var hasRequiredFields = _this.checkRequiredFields(newItem);
                    if (hasRequiredFields) {
                        queue.splice(len, 1);
                        var param = _this.processSendData(newItem);
                        _this.send(param);
                    }
                } else {
                    // 静默期发送
                    queue.splice(len, 1);
                    var param1 = _this.processSendData(logItem);
                    _this.send(param1);
                }
            }
        });
        /**
   * 上报所有的日志
   * @todo 上报策略
   */ _define_property(this, "sendAll", function() {
            var queue = _this.queue;
            var len = queue.length;
            while(len > 0){
                len--;
                var logItem = queue[len];
                // 聚合参数
                var param = _this.processSendData(logItem);
                // 如果返回null，说明需要跳过上报
                if (!param) {
                    queue.splice(len, 1);
                    continue;
                }
                // 为了异步拿到通用字段的值，对用户自主传的参数进行检测。而不是检测通过processSendData合并的参数
                var filterVal = _this.filterRequiredFields(_this.config);
                var finalParam = util.shadowMerge(logItem, filterVal); // 不能够堵塞后续的上报，所以需要也检测最新的config参数
                var hasRequiredFields = _this.checkRequiredFields(finalParam);
                queue.splice(len, 1);
                if (hasRequiredFields) {
                    if (_this.judgeIsValidLogItem(param)) {
                        _this.send(param);
                    }
                } else {
                    // 需要拿到数据再进行上报
                    _this.requiredFieldQueue.push(finalParam); // 先将需要上报的数据存到队列中
                }
            }
        });
        /**
   * 上报日志
   * 在SDK包根据不同端具体实现
   */ _define_property(this, "send", function(options) {
            console.warn("[ARMS WARN]没有对应的发送方法", options);
        });
        /**
   * 触发spa页面切换的方法，用于实现mcp性能数据收集
   * @param eventType
   */ _define_property(this, "markSPAChanged", function(eventType) {
            console.warn("[ARMS WARN]当前使用的sdk没有实现对应的markSPAChanged: ", eventType);
        });
        /**
   * 用户日志打点方法
   * @param logItem
   */ _define_property(this, "log", function(logItem) {
            var _this_config = _this.config, _this_config_sampling = _this_config.sampling, sampling = _this_config_sampling === void 0 ? 1 : _this_config_sampling, _this_config_enableSend = _this_config.enableSend, enableSend = _this_config_enableSend === void 0 ? true : _this_config_enableSend;
            if (typeof logItem !== "object") {
                return console.warn("data类型需要object");
            }
            // 是否禁用发送
            if (enableSend === false) {
                return;
            }
            // 采样率优先级， 插件采样率 > sdk config采样率
            var itemSampling = typeof logItem.sampling === "number" ? logItem.sampling : 1;
            var finalSample = itemSampling < 1 ? itemSampling : sampling;
            // 通过采样率过滤
            if (Math.random() > finalSample) {
                return;
            }
            // 采样还原字段
            var times = finalSample < 1 && finalSample > 0 ? Math.floor(1 / finalSample) : 1;
            // @todo 去重
            _this.queue.push(_object_spread_props(_object_spread({}, logItem), {
                times: times
            }));
            _this.sendAll();
        });
        /**
   * log方法的参数处理
   */ _define_property(this, "transformLogParam", function(type, logItem) {
            var params = logItem;
            params.type = type;
            var keyMap = logMap[type];
            for(var key in keyMap){
                var p = keyMap[key];
                params[p] = params[key];
                if (p !== key) {
                    delete params[key];
                }
            }
            return params;
        });
        /**
   * 上报error
   * @param e 错误对象，或错误msg
   * @param otherInfo 用户自定义其它信息，比如url/page等
   */ _define_property(this, "logError", function(e, otherInfo) {
            try {
                // 转化
                var data = util.processError(e) || {};
                var logItem = data;
                if (typeof otherInfo === "object") {
                    data = Object.assign(data, otherInfo);
                }
                var params = _this.transformLogParam("error", logItem);
                _this.log(params);
            } catch (error) {
            // do nothing
            }
        });
        /**
   * 上报perf
   * @param logItem
   */ _define_property(this, "logPerf", function(logItem) {
            try {
                // 转化
                var params = _this.transformLogParam("perf", logItem);
                _this.log(params);
            } catch (e) {
            // do nothing
            }
        });
        /**
   * 上报pv
   * @param logItem
   */ _define_property(this, "logPv", function(logItem) {
            try {
                var accountType = _this.config.accountType;
                var finalLogItem = _object_spread({}, logItem || {});
                if (typeof finalLogItem.changePage !== "undefined") {
                    delete finalLogItem.changePage;
                }
                if (accountType) {
                    finalLogItem.p4 = accountType;
                }
                var params = _this.transformLogParam("pv", finalLogItem);
                _this.log(params);
            } catch (e) {
            // do nothing
            }
        });
        /**
   * api上报
   * @param logItem
   */ _define_property(this, "logApi", function(logItem) {
            try {
                if (!logItem.api && logItem.url) {
                    logItem.api = logItem.url; // 兼容前期把api上报到url字段的情况
                }
                var params = _this.transformLogParam("api", logItem);
                if (params.p2 === undefined) {
                    params.p2 = logItem.success;
                }
                if (params.p10 === undefined) {
                    params.p10 = "xhr";
                }
                if (params.p6 && typeof params.p19 === "undefined") {
                    var _result;
                    var result = parseEagleeyeId(params.p6);
                    if ((_result = result) === null || _result === void 0 ? void 0 : _result.aserver) {
                        params.p19 = result.aserver;
                    }
                }
                _this.log(params);
            } catch (e) {
            // do nothing
            }
        });
        /**
   * 事件方法
   * @param logItem
   */ _define_property(this, "logEvent", function(logItem) {
            try {
                var params = _this.transformLogParam("event", logItem);
                _this.log(params);
            } catch (e) {
            // do nothing
            }
        });
        /**
   * 自定义测速
   * @param logItem
   */ _define_property(this, "logSpeed", function(logItem) {
            try {
                var params = _this.transformLogParam("speed", logItem);
                _this.log(params);
            } catch (e) {
            // do nothing
            }
        });
        /**
   * 自定义统计(和求统计、均值统计)
   * @param logItem
   */ _define_property(this, "logCalc", function(logItem) {
            try {
                var params = _this.transformLogParam("calc", logItem);
                _this.log(params);
            } catch (e) {
            // do nothing
            }
        });
        /**
   * form采集
   * @param logItem
   */ _define_property(this, "logForm", function(logItem) {
            try {
                var params = _this.transformLogParam("form", logItem);
                _this.log(params);
            } catch (e) {
            // do nothing
            }
        });
        /**
   * 采集自定义日志
   * @param logItem
   */ _define_property(this, "logCustom", function(logItem) {
            try {
                _this.log(_object_spread({
                    type: "custom"
                }, logItem));
            } catch (e) {
            // do nothing
            }
        });
        /**
   * 白屏采集
   * @param logItem
   */ _define_property(this, "logBlankScreen", function(logItem) {
            try {
                var params = _this.transformLogParam("blankScreen", logItem || {});
                _this.log(params);
            } catch (e) {
            // do nothing
            }
        });
        _define_property(this, "logRunTime", function(logItem) {
            try {
                var params = _this.transformLogParam("runtime", logItem || {});
                _this.log(params);
            } catch (e) {
            // do nothing
            }
        });
        _define_property(this, "logPerformance", function(logItem) {
            try {
                var params = _this.transformLogParam("performance", logItem || {});
                if (typeof params.p1 === "object" && params.p1) {
                    params.p1 = JSON.stringify(params.p1, null, 0);
                }
                if (typeof params.p11 === "object" && params.p11) {
                    params.p11 = JSON.stringify(params.p11, null, 0);
                }
                _this.log(params);
            } catch (e) {
            // do nothing
            }
        });
        _define_property(this, "logBizFlow", function(logItem) {
            try {
                var params = _this.transformLogParam("bizFlow", logItem || {});
                _this.log(params);
            } catch (e) {
            // do nothing
            }
        });
        _define_property(this, "initBizFlow", function(id) {
            var traceId = util.uuid();
            var cacheKey = "".concat(id).concat(_this.bizFlowCacheKeySplitStr).concat(traceId);
            var flowStartTime = new Date().getTime();
            _this.bizFlowInfoMap[cacheKey] = {
                startTime: flowStartTime,
                traceId: traceId,
                lastStepFinishTime: flowStartTime
            };
            return traceId;
        });
        _define_property(this, "logAutoAction", function(logItem) {
            try {
                var params = _this.transformLogParam("autoAction", logItem || {});
                _this.log(params);
            } catch (e) {
            // do nothing
            }
        });
        _define_property(this, "logABTest", function(logItem) {
            try {
                var params = _this.transformLogParam("abTest", logItem || {});
                _this.log(params);
            } catch (e) {
            // do nothing
            }
        });
        _define_property(this, "logPageText", function(logItem) {
            var nowUrl = _this.getUrl();
            var pvId = _this.config.pvId;
            if (!pvId || !logItem) {
                return;
            }
            if (!_this.pageTextCache.has(pvId)) {
                _this.pageTextCache.set(pvId, new Set());
                _this.pvIdTimestamps.set(pvId, Date.now());
            }
            var currentPvCache = _this.pageTextCache.get(pvId);
            var componentType = logItem.componentType, message = logItem.message;
            var cacheKey = "".concat(nowUrl, "-").concat(componentType, "-").concat(message);
            if (currentPvCache.has(cacheKey)) {
                return;
            }
            try {
                var params = _this.transformLogParam("pageText", logItem || {});
                _this.log(params);
                currentPvCache.add(cacheKey);
                _this.pageTextCache.set(_this.config.pvId || pvId, currentPvCache);
            } catch (e) {
            // do nothing
            }
        });
        /**
   * 添加插件
   * @param plugin
   */ _define_property(this, "addPlugin", function(plugin) {
            var param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (typeof plugin !== "function") {
                return;
            }
            return plugin.apply(_this, [
                _this,
                param
            ]);
        });
        /**
   * 执行hooks
   */ _define_property(this, "executeHooks", function(hooks) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            if (hooks.length === 0) {
                return;
            }
            return hooks.reduce(function() {
                var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], hook = arguments.length > 1 ? arguments[1] : void 0;
                var param = hook.apply(void 0, _to_consumable_array(params));
                // 前一个hook有返回值时，放到参数尾部
                if (typeof param !== "undefined") {
                    params.push(param);
                }
                return params;
            }, args);
        });
        /**
   * 给function添加执行hooks
   */ _define_property(this, "wrapperHooksFunc", function(func) {
            var _func_prototype, _func_prototype1;
            /**
     * 给函数添加钩子
     */ var wrappedFunc = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var beforeHooks = wrappedFunc.prototype.beforeHooks || [];
                var afterHooks = wrappedFunc.prototype.afterHooks || [];
                var beforeData = _this.executeHooks.apply(_this, [
                    beforeHooks
                ].concat(_to_consumable_array(args)));
                var currentData = func.apply(void 0, _to_consumable_array(args).concat([
                    beforeData
                ]));
                _this.executeHooks.apply(_this, [
                    afterHooks
                ].concat(_to_consumable_array(args), [
                    currentData
                ]));
                return currentData;
            };
            wrappedFunc.prototype = wrappedFunc.prototype || {};
            wrappedFunc.prototype.beforeHooks = ((_func_prototype = func.prototype) === null || _func_prototype === void 0 ? void 0 : _func_prototype.beforeHooks) || [];
            wrappedFunc.prototype.afterHooks = ((_func_prototype1 = func.prototype) === null || _func_prototype1 === void 0 ? void 0 : _func_prototype1.afterHooks) || [];
            return wrappedFunc;
        });
        _define_property(this, "sendPipe", function() {
            var pipeArr = _this.pipe;
            if (!Array.isArray(pipeArr)) return;
            try {
                if (typeof pipeArr[0] === "string") {
                    var name = pipeArr.shift();
                    var fn = name && _this[name];
                    typeof fn === "function" && fn.apply(_this, pipeArr);
                } else {
                    while(pipeArr.length){
                        var innerPipeArr = pipeArr.shift();
                        var name1 = innerPipeArr.shift();
                        var fn1 = name1 && _this[name1];
                        typeof fn1 === "function" && fn1.apply(_this, innerPipeArr);
                    }
                }
            } catch (e) {
                console.warn("[ARMS WARN]sendPipe错误：", e);
            }
        });
        /**
   * 安装执行
   */ _define_property(this, "install", function() {
            if (_this.status === "installed") {
                return;
            }
            _this.status = "installed";
            for(var key in _this){
                var func = _this[key];
                if (typeof func === "function" && needSupportHookFuncArr.indexOf(key) !== -1) {
                    _this[key] = _this.wrapperHooksFunc(func);
                }
            }
            _this.pluginsToUninstall = [];
            // 执行plugins
            var pluginConfigArr = _this.config.plugins || [];
            for(var i = 0; i < pluginConfigArr.length; i++){
                try {
                    var pConfig = pluginConfigArr[i];
                    if (!Array.isArray(pConfig) || typeof pConfig[0] !== "function") {
                        continue;
                    }
                    if (typeof pConfig[0].pluginName === "string" && pConfig[0].pluginName) {
                        _this.pluginConfigMap[pConfig[0].pluginName] = pConfig[1];
                    }
                    _this.pluginsToUninstall.push(_this.addPlugin(pConfig[0], pConfig[1]));
                } catch (e) {
                    var _e, _this_config;
                    _this.logCustom({
                        pid: "cn-cone-arms-sdk",
                        p1: "pluginInstallError",
                        c1: (_e = e) === null || _e === void 0 ? void 0 : _e.message,
                        c2: (_this_config = _this.config) === null || _this_config === void 0 ? void 0 : _this_config.pid,
                        c3: JSON.stringify(pluginConfigArr[i])
                    });
                }
            }
            // 执行预上报
            if (Array.isArray(_this.pipe) && _this.pipe.length) {
                _this.sendPipe();
            }
        });
        /**
   * SDK卸载
   */ _define_property(this, "uninstall", function() {
            if (_this.status === "uninstalled") {
                return;
            }
            _this.status = "uninstalled";
            var safeUninstall = function(uninstallMethods) {
                uninstallMethods.forEach(function(uninstallMethod) {
                    try {
                        if (uninstallMethod && typeof uninstallMethod === "function") {
                            uninstallMethod.apply(_this, [
                                _this
                            ]);
                        } else if (uninstallMethod && Array.isArray(uninstallMethod)) {
                            safeUninstall(uninstallMethod);
                        }
                    } catch (error) {
                        console.warn("[ARMS WARN]SDK卸载错误", error);
                    }
                });
            };
            safeUninstall(_this.pluginsToUninstall);
            _this.pluginsToUninstall = [];
        });
        var pageConfig = util.getPageMetaConfig();
        var defaultConfig = util.shadowMerge({
            requiredFields: [],
            sampling: 1
        }, pageConfig);
        this.config = util.shadowMerge(defaultConfig, config);
        if (pipe) {
            this.pipe = pipe;
        }
        var silentThreshold = this.config.silentThreshold || 5; // 静默期默认设置为5秒，超过5秒直接发送
        setTimeout(function() {
            // 设置静默期，超过规定时间没有拿到数据直接上报
            _this.sendRequiredFields();
        }, silentThreshold * 1000);
        setInterval(function() {
            // 定时清理过期的前端页面文案缓存
            _this.cleanupOldPvCache();
        }, 60 * 60 * 1000);
    }
    _create_class(Core, [
        {
            key: "logBizFlowStepFinish",
            value: function logBizFlowStepFinish() {
                var logItem = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                var id = logItem.id, step = logItem.step, other = _object_without_properties(logItem, [
                    "id",
                    "step"
                ]);
                var traceId = other.traceId, stepStartTime = other.startTime, _other_duration = other.duration, duration = _other_duration === void 0 ? 0 : _other_duration;
                if (!id || !step) {
                    return;
                }
                var bizFlowInfo = null;
                if (!traceId) {
                    Object.keys(this.bizFlowInfoMap).forEach(function(key) {
                        var keyArr = key.split(_this.bizFlowCacheKeySplitStr);
                        console.log(_this.bizFlowInfoMap[key]);
                        if (keyArr[0] === id && (!bizFlowInfo || bizFlowInfo.startTime < _this.bizFlowInfoMap[key].startTime)) {
                            traceId = keyArr[1];
                            bizFlowInfo = _this.bizFlowInfoMap[key];
                        }
                    });
                }
                if (!traceId) {
                    return;
                }
                if (!stepStartTime) {
                    if (!bizFlowInfo) {
                        return;
                    }
                    stepStartTime = bizFlowInfo.lastStepFinishTime;
                }
                if (!duration && stepStartTime) {
                    duration = new Date().getTime() - stepStartTime;
                }
                var cacheKey = "".concat(id).concat(this.bizFlowCacheKeySplitStr).concat(traceId);
                if (cacheKey in this.bizFlowInfoMap) {
                    var currentTime = new Date().getTime();
                    this.bizFlowInfoMap[cacheKey].lastStepFinishTime = currentTime;
                    bizFlowInfo = this.bizFlowInfoMap[cacheKey];
                    this.logBizFlow(_object_spread({
                        id: id,
                        step: step,
                        traceId: traceId,
                        duration: duration,
                        startTime: stepStartTime,
                        totalDuration: currentTime - bizFlowInfo.startTime,
                        isLastStep: false,
                        success: true
                    }, other));
                }
            }
        },
        {
            key: "setBizFlowInfo",
            value: function setBizFlowInfo(bizFlowInfoMap) {
                this.bizFlowInfoMap = bizFlowInfoMap;
            }
        },
        {
            key: "getBizFlowInfo",
            value: function getBizFlowInfo() {
                return this.bizFlowInfoMap;
            }
        },
        {
            key: "getPluginConfig",
            value: function getPluginConfig(pluginName) {
                return this.pluginConfigMap[pluginName] || {};
            }
        },
        {
            key: "getUrl",
            value: function getUrl() {
                return util.getUrl(this.config);
            }
        },
        {
            key: "getBizLanguage",
            value: function getBizLanguage1() {
                return getBizLanguage();
            }
        },
        {
            key: "fixPvId",
            value: // 根据上报的url值，修正pvId
            function fixPvId(pvId, url) {
                var _this = this;
                if (!pvId || this.pvIdMap[pvId] && this.pvIdMap[pvId] !== url) {
                    var newPvId = this.generateRandomId();
                    this.pvIdMap[newPvId] = url;
                    this.setConfig({
                        pvId: newPvId
                    });
                    return newPvId;
                } else {
                    this.pvIdMap[pvId] = url;
                }
                // 清除缓存,只保留当前pvId
                Object.keys(this.pvIdMap).forEach(function(key) {
                    if (key !== pvId) {
                        delete _this.pvIdMap[key];
                    }
                });
                return pvId;
            }
        },
        {
            key: "judgeIsValidLogItem",
            value: /**
   * 检测是否是有效的logItem
   * @param logItem
   * @returns
   */ function judgeIsValidLogItem(logItem) {
                if (typeof logItem !== "object") {
                    return false;
                }
                if (typeof logItem.type !== "string" || !logItem.type) {
                    console.warn("日志类型（type）必填，且为string类型");
                    return false;
                }
                return true;
            }
        },
        {
            key: "cleanupOldPvCache",
            value: // 清理过期的前端页面文案缓存
            // 比较每个 pvId 的生成时间与当前时间,如果 pvId 的存活时间超过了1小时，则从 pageTextCache 和 pvIdTimestamps 中删除对应的 pvId
            function cleanupOldPvCache() {
                var _this = this;
                var expirationTime = 60 * 60 * 1000;
                var now = Date.now();
                this.pvIdTimestamps.forEach(function(timestamp, pvId) {
                    if (now - timestamp > expirationTime) {
                        _this.pageTextCache.delete(pvId);
                        _this.pvIdTimestamps.delete(pvId);
                    }
                });
            }
        }
    ]);
    return Core;
}();
export { Core as default };

 //# sourceMappingURL=core.js.map